import { render } from "./SimpleNotesPageShell.vue?vue&type=template&id=24c181a5&scoped=true"
import script from "./SimpleNotesPageShell.vue?vue&type=script&lang=js"
export * from "./SimpleNotesPageShell.vue?vue&type=script&lang=js"

import "./SimpleNotesPageShell.vue?vue&type=style&index=0&id=24c181a5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24c181a5"]])

export default __exports__